import NacelleGraphQLConnector, {
  ProcessCheckoutParams
} from '../connectors/graphql/nacelleGraphQLConnector'
import { Checkout } from '../objects/checkout'

interface NacelleCheckoutParams {
  connector?: NacelleGraphQLConnector
  endpoint?: string
  spaceId?: string
  token?: string
}

export default class NacelleCheckout {
  connector: NacelleGraphQLConnector

  constructor(params: NacelleCheckoutParams) {
    if (params.connector) {
      this.connector = params.connector
    } else if (params.endpoint && params.spaceId && params.token) {
      this.connector = new NacelleGraphQLConnector({
        endpoint: params.endpoint,
        spaceId: params.spaceId,
        token: params.token
      })
    } else {
      throw new Error('Missing parameters to initialize checkout module')
    }
  }

  process(params: ProcessCheckoutParams): Promise<Checkout> {
    return this.connector.processCheckout(params)
  }

  get(params: { id: string; url: string }): Promise<Checkout> {
    if (typeof params.id === 'undefined' || params.id.length === 0) {
      throw new Error(
        'Missing parameter "id". Querying for a checkout requires a checkout Id.'
      )
    }

    if (typeof params.url === 'undefined' || params.url.length === 0) {
      throw new Error(
        'Missing parameter "url". Querying for a checkout requires a checkout url.'
      )
    }

    return this.connector.queryCheckout(params)
  }
}
